<template>
	<div class="AppSalesPerformanceCard">
		<div class="heading">
			<h4 class="text-xl text-app-dashboard-heading">
				Sales performance by location
			</h4>
			<p class="text-sm text-amp-heading2 py-1">
				{{ today }}
			</p>
		</div>
		<div class="all-cards">
			<div class="sales-performance-card">
				<div class="card-inner-sec">
					<div class="card-img">
						<img
							src="../../../assets/images/AppSalesPerformanceCard/cart (1).png"
						/>
					</div>
					<div class="card-text">
						<span class="text-black text-xs">
							Company Sales
						</span>
						<span class="viewers">
							{{ summary.sales }}
						</span>
					</div>
				</div>
			</div>

			<div class="sales-performance-card">
				<div class="card-inner-sec">
					<div class="card-img">
						<img
							src="../../../assets/images/AppSalesPerformanceCard/money.png"
						/>
					</div>
					<div class="card-text">
						<span class="text-black text-xs">
							ADT
						</span>
						<span class="viewers">
							{{ summary.adt }}
						</span>
					</div>
				</div>
			</div>

			<div class="sales-performance-card">
				<div class="card-inner-sec">
					<div class="card-img">
						<img
							src="../../../assets/images/AppSalesPerformanceCard/parking-card.png"
						/>
					</div>
					<div class="card-text">
						<span class="text-black text-xs">
							AT
						</span>
						<span class="viewers">
							{{ summary.at }}
						</span>
					</div>
				</div>
			</div>

			<div class="sales-performance-card">
				<div class="card-inner-sec">
					<div class="card-img">
						<img
							src="../../../assets/images/AppSalesPerformanceCard/edit (1).png"
						/>
					</div>
					<div class="card-text">
						<span class="text-black text-xs">
							IPT
						</span>
						<span class="viewers">
							{{ summary.ipt }}
						</span>
					</div>
				</div>
			</div>

			<div class="sales-performance-card">
				<div class="card-inner-sec">
					<div class="card-img">
						<img
							src="../../../assets/images/AppSalesPerformanceCard/profits.png"
						/>
					</div>
					<div class="card-text">
						<span class="text-black text-xs">
							YTD Sales
						</span>
						<span class="viewers">
							{{ summary.ytd }}
						</span>
					</div>
				</div>
			</div>

			<!-- <div class="sales-performance-card">
				<div class="card-inner-sec">
					<div class="card-img">
						<img
							src="../../../assets/images/AppSalesPerformanceCard/world (1).png"
						/>
					</div>
					<div class="card-text">
						<span class="text-black text-xs">
							Growth
						</span>
						<span class="viewers">
							{{ summary.growth }}
						</span>
					</div>
				</div>
			</div> -->
		</div>
	</div>
</template>

<script>
import { Dates } from "../../../../mixins/dates.mixin";
import { mapActions, mapState } from "vuex";
import moment from "moment";
export default {
	name: "AppSalesPerformanceCard",
	mixins: [Dates],
	props: [],
	data() {
		return {
			today: moment(
				new Date(new Date().setDate(new Date().getDate() - 1))
			).format("dddd, Do MMMM YYYY")
		};
	},
	computed: {
		...mapState("CommonStore", ["summary"])
	},
	created() {
		this.parseDate();
		this.getSummary({
			start_date: moment()
				.subtract(1, "day")
				.format("YYYY-MM-DD"),
			end_date: moment()
				.subtract(1, "day")
				.format("YYYY-MM-DD")
		});
	},
	methods: {
		...mapActions("CommonStore", ["getSummary"]),
		parseDate() {
			var currentDate = this.currentDateYYYYMMDD();
			var dayOfWeek = this.getDayOfWeek(currentDate);
			var monthOfYear = this.getMonthOfYear(currentDate);
			var dayOfMonth = this.getDayOfMonth(currentDate);
			var dayOfMonthOrdinal = this.ordinal(dayOfMonth);
			var fullYear = this.getFullYear(currentDate);
			return (
				"Today is " +
				dayOfWeek +
				", " +
				dayOfMonthOrdinal +
				" " +
				monthOfYear +
				" " +
				fullYear
			);
			// console.log(currentDate.getFullYear());
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./AppSalesPerformanceCard.scss";
@import "./AppSalesPerformanceCardM.scss";
</style>
